import axios from 'axios';
import * as types from './AdminHelpDesk.types';
import { showNotification, empty } from './../../utils';
import * as loginActions from './../Login/Login.actions';
import * as selectors from './AdminHelpDesk.selectors';
import * as dialog from './../common/dialog';
import * as layoutActions from './../Layout/Layout.actions';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchRequests = () => (dispatch, getState) => {
    const pagination = selectors.getPagination(getState());
    const sort = selectors.getSort(getState());
    const search = selectors.getSearch(getState());
    const searchType = selectors.getSearchType(getState());

    let params = [];
    params.push('active-page=' + pagination.activePage);
    params.push('elements-per-page=' + pagination.elementsPerPage);
    params.push('sort-column=' + sort.column);
    params.push('sort-type=' + sort.type);
    params.push('search=' + search);
    params.push('search-type=' + searchType);
    params.push('expand=log_history');

    dispatch({ type: types.FETCH_REQUESTS, payload: null });
    axios.get(apiUrl + '/uthealth-help-request/admin-index?' + (params.length === 0 ? '' : '&' + params.join('&')),
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_REQUESTS_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_REQUESTS_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const sendResponse = () => (dispatch, getState) => {
    const request = selectors.getRequest(getState());
    const responseMessage = selectors.getResponseMessage(getState());

    if (empty(responseMessage)) {
        return showNotification('Complete information', 'Enter the Message for the response', 'info');
    }

    var formData = new FormData();
    formData.append('id', request.id);
    formData.append('message', responseMessage);

    dispatch({ type: types.SEND_RESPONSE, payload: null });
    axios.post(apiUrl + '/uthealth-help-request/send-response', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.SEND_RESPONSE_SUCCESS, payload: response.data });
            dispatch(dialog.actions.hideDialog('help-desk-form-modal'));
            showNotification('Response sent', 'The response has been sent successfully', 'success');
            dispatch(fetchRequests());
            dispatch(resetRequest());
            dispatch(setResponseMessage(''));
            dispatch(layoutActions.fetchHelpRequestOpenTickets());
        })
        .catch((error) => {
            dispatch({ type: types.SEND_RESPONSE_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const closeTicket = () => (dispatch, getState) => {
    const request = selectors.getRequest(getState());

    var formData = new FormData();
    formData.append('id', request.id);

    dispatch({ type: types.CLOSE_TICKET, payload: null });
    axios.post(apiUrl + '/uthealth-help-request/close-ticket', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CLOSE_TICKET_SUCCESS, payload: response.data });
            dispatch(dialog.actions.hideDialog('help-desk-form-modal'));
            showNotification('Ticket Closed', 'The ticket has been closed successfully', 'success');
            dispatch(fetchRequests());
            dispatch(resetRequest());
            dispatch(layoutActions.fetchHelpRequestOpenTickets());
        })
        .catch((error) => {
            dispatch({ type: types.CLOSE_TICKET_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const setIdModal = (id) => (dispatch) => {
    dispatch({
        type: types.SET_ID_MODAL,
        payload: id
    });
}

export const setActivePage = (value) => (dispatch, getState) => {
    new Promise(resolve => {
        dispatch({
            type: types.SET_ACTIVE_PAGE,
            payload: value,
        });
        resolve();
    }).then(() => {
        dispatch(fetchRequests());
    });
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}

export const setRequestField = (field, value) => (dispatch) => {
    dispatch({
        type: types.SET_REQUEST_FIELD,
        payload: { field, value },
    })
}

export const setRequest = (id) => (dispatch, getState) => {
    const requests = selectors.getRequests(getState());

    let selectedItem = null;
    for (const request of requests) {
        if (parseInt(request.id) === parseInt(id)) {
            selectedItem = request;
            break;
        }
    }

    dispatch({
        type: types.SET_REQUEST,
        payload: selectedItem,
    })
}

export const resetRequest = () => (dispatch) => {
    dispatch({
        type: types.RESET_REQUEST,
        payload: {},
    })
}

export const setSort = (column, type) => (dispatch) => {
    new Promise(resolve => {
        dispatch({
            type: types.SET_SORT,
            payload: { column, type }
        });
        resolve();
    }).then(() => {
        dispatch(fetchRequests());
    });
}

export const setSearch = (value) => dispatch => {
    dispatch({
        type: types.SET_SEARCH,
        payload: value,
    });
}

export const setSearchType = (value) => dispatch => {
    dispatch({
        type: types.SET_SEARCH_TYPE,
        payload: value,
    });
}

export const setResponseMessage = (value) => dispatch => {
    dispatch({
        type: types.SET_RESPONSE_MESSAGE,
        payload: value,
    });
}